export default {
  data() {
    return {
      emailReg: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w+)+$/,
    };
  },
  methods: {
    isWelformed(email) {
      return this.emailReg.test(email);
    },
    mask(email) {
      return email.replace(/^(.)(.*)(.@.*)$/, (_, a, b, c) => a + b.replace(/./g, '*') + c);
    },
  },
};
